export const services = [
  {
    id: 1,
    title: 'Deep Tissue Massage',
    description:
      'Massages might use slow, rhythmic compressions and stretching, gentle, flowing strokes, or intense pressure',
    image: 'massage.jpg',
    price: 115,
  },
  {
    id: 2,
    title: 'Hot Stone Treatment',
    description:
      'Client is pampered with massage, hot stone and gua sha to improve overall blood circulation and immunity',
    image: 'hotstone.jpg',
    price: 95,
  },
  {
    id: 3,
    title: 'Facial Treatment',
    description:
      'This skin boosting facial includes facial cleansing and exfoliation along with a deeply relaxing facial massage',
    image: 'facial.jpg',
    price: 80,
  },
  {
    id: 4,
    title: 'Decompression Cupping Therapy',
    description:
      'Reverse compression technique that works to help improve circulation and relieve muscle discomfort',
    image: 'cupping.jpg',
    price: 100,
  },
];

export const products = [
  {
    id: 1,
    title: 'Spa Gift Basket Lavender Fragrance',
    description:
      'Luxurious 8pc Gift Baskets for Women, Cute Bath Tub Holder - Best Holiday Gift Set for Women Includes Shower Gel, Bubble Bath and Body Butter',
    price: 65,
    bgColor: '#D9D7F1',
  },
  {
    id: 2,
    title: 'Complete Spa Facial Package ',
    description:
      'This package gives you everything you need to treat yourself to daily spa quality facial care, from the convenience of your own home',
    price: 90,
    bgColor: '#FFFDDE',
  },
  {
    id: 3,
    title: 'Foot Bath Set',
    description:
      'This traditional Moroccan beauty accessory is a must-have to remove calluses on feet and elbows without scraping or irritation',
    price: 60,
    bgColor: '#E7FBBE',
  },
  {
    id: 4,
    title: 'Body Care Assortment',
    description:
      'Body Care Assortment is an exotic combination of essential skincare products specially designed to soothe your skin',
    price: 115,
    bgColor: '#FFCBCB',
  },
];
